import React from 'react';
import { FiShoppingBag, FiDollarSign, FiUsers, FiCheckCircle } from 'react-icons/fi';

const StatCard = ({ title, value, icon: Icon, color }) => (
  <div className="bg-white rounded-xl shadow-sm p-6">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-500 text-sm">{title}</p>
        <p className="text-2xl font-bold text-gray-800 mt-1">{value}</p>
      </div>
      <div className={`p-3 rounded-full ${color}`}>
        <Icon className="w-6 h-6 text-white" />
      </div>
    </div>
  </div>
);

export default function StatsCards({ stats }) {
  if (!stats) return null;

  const cards = [
    { title: 'Total Orders', value: stats.total || 0, icon: FiShoppingBag, color: 'bg-blue-500' },
    { title: 'Today\'s Orders', value: stats.today || 0, icon: FiCheckCircle, color: 'bg-green-500' },
    { title: 'This Week', value: stats.thisWeek || 0, icon: FiUsers, color: 'bg-purple-500' },
    { title: 'Revenue', value: `$${stats.totalRevenue || 0}`, icon: FiDollarSign, color: 'bg-orange-500' },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {cards.map((card, index) => (
        <StatCard key={index} {...card} />
      ))}
    </div>
  );
}
